import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { TextField, InputAdornment } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import { getFunctions, httpsCallable } from "firebase/functions";

export default function EmailPopupDialog({ buttonTitle }) {
  const [open, setOpen] = React.useState(false);
  const functions = getFunctions();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [addrEmail, setAddrEmail] = React.useState("");
  const [addrPhone, setAddrPhone] = React.useState("");
  const [name, setName] = React.useState("");

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    const formattedNumber = formatPhoneNumber(e.target.value);
    setAddrPhone(formattedNumber);
  };
  const formatPhoneNumber = (input) => {
    // Replace all non-digit characters with an empty string
    const cleaned = input.replace(/\D/g, "");

    // Apply phone number formatting
    if (cleaned.length <= 3) {
      return cleaned;
    } else if (cleaned.length <= 7) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
  };
  const handleInputChange = (event, fieldSetter, errorSetter) => {
    const value = event.target.value;
    fieldSetter(value);

    // Check if the input is empty and set the error state accordingly
    //errorSetter(value.trim() === '');
  };

  async function sendEmailVIP() {
    const addMessage = httpsCallable(functions, "sendVIPEmail");
    addMessage({ email: addrEmail, phone: addrPhone, name: name })
      .then((result) => {
        console.log(result);
      })
      .catch((err) => {
        console.log("ERROR", err);
      });
    setOpen(false);
  }

  return (
    <React.Fragment>
      <Button variant="contained" onClick={handleClickOpen}>
        {buttonTitle}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="tac">
          {"RECEIVE MORE DISCOUNTS"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="tac">
              {buttonTitle == "Continue Checkout" && (
                <>Your cart has more than $100,000. </>
              )}
              Please get in touch with us by emailing{" "}
              <a href="email:support@goldguys.com ">support@goldguys.com</a>{" "}
              with your name and phone number to receive further discounts. One
              of our reps will contact you.
            </div>
            <br />
            <hr />
            <TextField
              id="outlined-basic"
              label="Name *"
              variant="outlined"
              fullWidth
              value={name}
              onChange={(e) => {
                handleInputChange(e, setName, null);
              }}
            />
            <br />
            <br />
            <TextField
              id="outlined-basic"
              label="Email *"
              variant="outlined"
              fullWidth
              value={addrEmail}
              onChange={(e) => {
                handleInputChange(e, setAddrEmail, null);
              }}
            />
            <br />
            <br />
            <TextField
              id="outlined-basic"
              label="Phone Number *"
              variant="outlined"
              type=""
              fullWidth
              value={addrPhone}
              onChange={handlePhoneNumberChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneIcon />
                  </InputAdornment>
                ),
              }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              sendEmailVIP();
            }}
            autoFocus
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
